import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from "react";

import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

const Checkbox = forwardRef<
  ElementRef<typeof CheckboxPrimitive.Root>,
  ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    isLoading?: boolean;
  }
>(({ className, isLoading = false, disabled, ...props }, ref) => (
  <CheckboxPrimitive.Root
    className={cnTwMerge(
      "peer h-[18px] w-[18px] shrink-0 rounded-[3.5px] border border-text/secondary hover:border-text/primary ring-offset-white focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-text/interactive focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-text/interactive data-[state=checked]:text-background/primary  ",
      isLoading ? "skeleton-box" : "",
      className,
    )}
    disabled={isLoading || disabled}
    ref={ref}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cnTwMerge("flex items-center justify-center text-current")}
    >
      <svg
        fill="none"
        height="18"
        viewBox="0 0 18 18"
        width="18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          clipRule="evenodd"
          d="M14.625 5.92105L7.125 13.5L3.375 9.71053L4.78125 8.28947L7.125 10.6579L13.2188 4.5L14.625 5.92105Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </svg>
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
